import axios from 'axios';
import { AuthContextValue } from '@/contexts/auth';
import { API_PREFIX } from '@/constants';
import { EventStatus } from '.';


export interface EventDetail {
  id: UKey;
  creator: string;
  extUserId: string;
  dynamicTime: string;
  pendingStatus: string;
  dynamicContent: string;
  pendingOverdue: string | null;
  createTime: string;
  avatar: string;
  nickName: string;
}

export interface EventListResult {
  total: number;
  notDealTotal: number;
  finishTotal: number;
  page: number;
  pageSize: number;
  customerPending: EventDetail[];
}

interface QueryReminderListParams extends Pagination {
  status: EventStatus;
  auth: AuthContextValue;
}

export const queryReminderList = async ({ status, auth, current, pageSize }: QueryReminderListParams) => {
  const { corpId, userId } = auth;
  const res = await axios.get<EventListResult>(`${API_PREFIX.CUSTOMER}/customerDynamic/getCustomerPending`, {
    params: { userId, corpId, pendingType: status, page: current, pageSize }
  });
  if (res && res.data) {
    const { total, notDealTotal, finishTotal, customerPending: data } = res.data;
    const statusAnalysis = {
      [EventStatus.pending]: notDealTotal,
      [EventStatus.finished]: finishTotal
    };
    return {
      data,
      pagination: {
        current: res.data.page,
        pageSize: res.data.pageSize,
        total: statusAnalysis[status]
      },
      analysis: {
        total,
        status: statusAnalysis
      }
    };
  }
}

export const finishTodoEvent = async (id: UKey, auth: AuthContextValue) => {
  const { corpId, userId } = auth;
  await axios.put(`${API_PREFIX.CUSTOMER}/customerDynamic/updateCustomerPending`, { id, corpId, userId });
}

export const queryReminderStatus = async (id: UKey, auth: AuthContextValue) => {
  if (!id) {
    return EventStatus.pending;
  }
  const { corpId } = auth;
  const res = await axios.get<EventStatus>(`${API_PREFIX.CUSTOMER}/customerDynamic/getCustomerPendStatus`, {
    params: { id, corpId }
  });
  return res.data;
}
